<script setup lang="ts">
import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'
import { getVueAssetImagePath } from '@/lib/utils'

defineProps<{
	pageContent: PageContent
}>()
</script>

<template>
	<div class="bs-container">
		<div class="col-span-12">
			<div class="flex w-full flex-col gap-acquaintances">
				<div
					class="typography-h2-str text-center"
					v-html="pageContent.choosePlusPlan.title"
				></div>
				<div class="flex flex-col gap-20px mdp:flex-row">
					<div
						v-for="(item, index) in pageContent.choosePlusPlan.items"
						:key="index"
						class="flex flex-1 flex-col gap-8px rounded-[12px] bg-white p-good-friends"
					>
						<img
							:src="`${getVueAssetImagePath(item.icon)}.svg`"
							class="h-[64px] w-[64px]"
							loading="lazy"
							:alt="`shipment protection shipping choose plus plan icon ${item.icon}`"
						/>
						<div class="flex flex-col gap-8px">
							<div class="typography-s1-str text-n-950">{{ item.title }}</div>
							<div class="typography-b2-reg text-n-800">
								{{ item.description }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
